<template>
  <div v-if="membershipFee.attributes">
    <h2
      class="m-0"
      v-text="membershipFee.attributes.title"
    />
    <MembershipFeeInfo
      v-if="!showForm"
      @showForm="showForm = true"
    />
    <MembershipFeeForm
      v-else
      @hideForm="showForm = false"
    />
  </div>
</template>

<script type="text/babel">
import MembershipFeeInfo from './MembershipFeeInfo'
import MembershipFeeForm from './MembershipFeeForm'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'MembershipFeeContainer',
  components: {
    MembershipFeeForm,
    MembershipFeeInfo,
  },
  data() {
    return {
      hasErrors: false,
      showForm: false,
    }
  },
  async created() {
    try {
      await this.paymentsGetMembershipFee()
    } catch (errors) {
      this.$store.commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: 'There was a problem retrieving the membership fee.',
      })
    }
  },
  computed: {
    ...mapState({
      membershipFee: state => state.payments.membershipFee,
    }),
  },
  methods: {
    ...mapActions([
      'paymentsGetMembershipFee',
    ]),
  },
}
</script>
